import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../context/useAuth';

const AdminRoute = ({ component: Component, ...rest }) => {
  const { token, isAdmin } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        token && isAdmin() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default AdminRoute;